import { Box, Typography } from '@mui/material';
import useAuth from 'hooks/useAuth';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchOrderDriveQuery } from 'store/api/drive.api';
import Cover from 'ui-component/Cover';
import Drive, { drivePathAtom } from 'ui-component/drive/Drive';
import { orderIdAtom } from 'views/pages/order/OrderManagePage';
import { FileBrowser } from '@aperturerobotics/chonky';

interface Props {
    orderNo: string;
}

const OrderDrive = ({ orderNo }: Props) => {
    const { user } = useAuth();
    const [orderId] = useAtom(orderIdAtom);
    const { t } = useTranslation();

    const initialPath = `drive/orders/${orderNo}`;

    const [drivePath, setDrivePath] = useAtom(drivePathAtom);

    useEffect(() => setDrivePath(initialPath), [initialPath]);

    const { data: orderFileMap, isFetching: isOrderFileMapFetching } = useFetchOrderDriveQuery(
        { target: drivePath!, orderId: orderId!, userId: user!.id },
        { skip: !user || !orderId || !drivePath, refetchOnMountOrArgChange: true }
    );

    if (!drivePath) return <Cover sx={{ height: 532 }} />;
    else if (orderFileMap && Object.keys(orderFileMap).length === 0)
        return (
            <Box
                sx={{
                    height: '100%',
                    '.chonky-searchFieldContainer': { display: 'none' },
                    '.chonky-fileListEmpty': { display: 'none' }
                }}
            >
                <FileBrowser files={[]}>
                    <Box
                        sx={(theme) => ({
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                            color: theme.palette.text.disabled,
                            textAlign: 'center'
                        })}
                    >
                        <Typography
                            sx={{
                                fontSize: '1.2em'
                            }}
                        >
                            {t(`pages.drive_page.error.403.message`)}
                        </Typography>
                    </Box>
                </FileBrowser>
            </Box>
        );

    return (
        <Box sx={{ height: 500 }}>
            <Drive baseFileMap={orderFileMap} isBaseFileMapFetching={isOrderFileMapFetching} pathingDisabled />
        </Box>
    );
};

export default OrderDrive;
